module.exports = __webpack_public_path__ + "static/img/dbq0309.d5177b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dbq0309.jpg
// module id = NBMO
// module chunks = 0